
export default {
  'terms.title': 'Terms and Conditions',
  'terms.subtitle': 'Please read the following terms and conditions carefully before using our services.',
  'terms.last_updated': 'Last updated:',
  'terms.introduction.title': 'Introduction',
  'terms.introduction.content': 'Welcome to Pink Paradise. By accessing our website and using our services, you agree to comply with these terms and conditions. We recommend that you read them carefully.',
  
  'privacy.title': 'Privacy Policy',
  'privacy.subtitle': 'How we collect, use, and protect your personal information.',
  'privacy.last_updated': 'Last updated:',
  'privacy.introduction.title': 'Our Privacy Policy',
  'privacy.introduction.content': 'At Pink Paradise, we value and respect your privacy. This policy outlines what information we collect, how we use it, and your rights regarding your data.',
  
  'cookies.title': 'Cookie Policy',
  'cookies.subtitle': 'Information about the cookies we use on our website.',
  'cookies.last_updated': 'Last updated:',
  'cookies.introduction.title': 'Cookie Usage',
  'cookies.introduction.content': 'Our website uses cookies to enhance your experience. This policy explains what cookies are, how we use them, and how you can manage them.',
  
  'content_policy.title': 'Content Policy',
  'content_policy.subtitle': 'Standards for permitted content on our platform.',
  'content_policy.last_updated': 'Last updated:',
  'content_policy.introduction.title': 'Our Content Policy',
  'content_policy.introduction.content': 'Pink Paradise is committed to maintaining a safe and respectful environment. This policy sets out the content standards that all users must follow.',
  
  'about.title': 'About Us',
  'about.subtitle': 'Learn more about Pink Paradise.',
  'about.mission_title': 'Our Mission',
  'about.mission_content': 'At Pink Paradise, we\'re committed to creating a safe, discreet, and premium environment where adults can connect for mutually beneficial relationships.',
  'about.why_choose': 'Why Choose Pink Paradise',
  'about.safety_first': 'Safety First',
  'about.quality_selection': 'Quality Selection',
  'about.discreet_service': 'Discreet Service',
  'about.support': '24/7 Support',
  
  'how_it_works.title': 'How It Works',
  'how_it_works.subtitle': 'A secure, discreet platform connecting clients with verified escorts for authentic experiences.',
  'how_it_works.for_clients': 'For Clients',
  'how_it_works.for_escorts': 'For Escorts',
  'how_it_works.secure_private': 'Secure & Private',
  'how_it_works.verified_profiles': 'Verified Profiles',
  'how_it_works.secure_payments': 'Secure Payments',
  
  'blog.title': 'Blog',
  'blog.subtitle': 'Insights, tips, and stories from our community and experts to help you navigate the world of online connections.',
  'blog.read_article': 'Read Article',
  'blog.load_more': 'Load More Articles',
  
  'faq.title': 'Frequently Asked Questions',
  'faq.subtitle': 'Find answers to the most common questions about our platform and services.',
  'faq.search_placeholder': 'Search for answers...',
  'faq.search_button': 'Search',
  'faq.still_questions': 'Still have questions?',
  'faq.contact_support': 'Can\'t find the answer you\'re looking for? Please contact our friendly support team.',
  'faq.contact_button': 'Contact Support',
  
  'safety_tips.title': 'Safety Tips',
  'safety_tips.subtitle': 'Protect yourself while using our platform with these essential safety tips.',
  
  'security.title': 'Security',
  'security.subtitle': 'How we protect your information and maintain your security on our platform.',
  
  'support.title': 'Support',
  'support.subtitle': 'We\'re here to help. Contact our support team for any inquiries or assistance.',
  'support.contact_us': 'Contact Us',
  'support.form.name': 'Your Name',
  'support.form.email': 'Your Email',
  'support.form.subject': 'Subject',
  'support.form.message': 'Message',
  'support.form.submit': 'Send Message'
};
